module.exports = __webpack_public_path__ + "static/media/tpn-events-on-demand-2.cc039656.jpg";